<template>
  <Teleport to="body">
    <div class="modal fade" id="ModalConfiguracoesUsuario" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-md">
        <div class="settings-inner-blk p-0">
          <div class="sell-course-head comman-space">
            <div class="modal-content border-0">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('userSettings.title') }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="$t('userSettings.closeModalAria')" />
              </div>

              <div class="modal-body">
                <ul class="nav nav-tabs mb-3">
                  <li class="nav-item">
                    <a
                      :class="['nav-link', tabAtiva === 'franqueado' ? 'active' : '']"
                      href="javascript:void(0)"
                      @click="tabAtiva = 'franqueado'"
                    >
                      {{ $t('userSettings.tabFranqueado') }}
                    </a>
                  </li>
                </ul>

                <div v-if="tabAtiva === 'franqueado'">
                  <div class="form-group mb-2">
                    <label class="form-label">{{ $t('userSettings.defaultUnit') }}</label>
                    <MultselectFormFranqueadoUnidade
                      v-model="FranqueadoUnidadeSel"
                      :placeholder="$t('userSettings.defaultUnitPlaceholder')"
                    />
                  </div>
                  <p class="text-muted text-xs mb-2">{{ $t('userSettings.defaultUnitHint') }}</p>
                  <button
                    type="button"
                    class="btn btn-outline-danger btn-sm"
                    :disabled="!FranqueadoUnidadeSel"
                    @click="removerUnidadePadrao"
                  >
                    <i class="feather-x me-1" />
                    {{ $t('userSettings.remove') }}
                  </button>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  id="btnFecharModalConfiguracoesUsuario"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {{ $t('userSettings.cancel') }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="salvando"
                  @click="salvar"
                >
                  {{ $t('userSettings.save') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      class="display-off"
      id="btnAbrirModalConfiguracoesUsuario"
      data-bs-toggle="modal"
      data-bs-target="#ModalConfiguracoesUsuario"
    />
  </Teleport>
</template>

<script>
import Helper from "../helpers/helper.service";
import userService from "../helpers/user.service";
import authService from "../Services/Auth.service";
import usuarioService from "../Services/Usuario.service";

export default {
  name: "ModalConfiguracoesUsuario",
  props: {
    abrir: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["fechar"],
  data() {
    return {
      tabAtiva: "franqueado",
      salvando: false,
      FranqueadoUnidadeSel: null,
    }
  },
  methods: {
    limpar() {
      this.tabAtiva = "franqueado"
      this.salvando = false
      this.FranqueadoUnidadeSel = null
    },
    removerUnidadePadrao() {
      this.FranqueadoUnidadeSel = null
    },
    aplicarUnidadePadraoSessao() {
      const idPadrao = userService.getUser()?.IdFranqueadoUnidadePadrao ?? null
      this.FranqueadoUnidadeSel = userService.findFranqueadoUnidadeOption(idPadrao)
    },
    atualizarSessaoUsuario(idFranqueadoUnidadePadrao) {
      const session = userService.getLocalUser(false)
      if (!session?.Usuario?.Usuario)
        return

      session.Usuario.Usuario.IdFranqueadoUnidadePadrao = idFranqueadoUnidadePadrao
      userService.saveUser(session)
    },
    abrirModal() {
      this.limpar()
      this.aplicarUnidadePadraoSessao()
      document.getElementById("btnAbrirModalConfiguracoesUsuario")?.click()
    },
    fecharModal() {
      this.limpar()
      this.$emit("fechar")
    },
    async salvar() {
      try {
        this.salvando = true
        swalLoading.fire()

        const idFranqueadoUnidadePadrao = this.FranqueadoUnidadeSel?.IdFranqueadoUnidade ?? null
        const result = await usuarioService.atualizarConfiguracoes({
          IdFranqueadoUnidadePadrao: idFranqueadoUnidadePadrao,
        })
        if (!result.Success)
          throw new Error(Helper.getMessageError(result))

        const idSalvo = result.Data?.IdFranqueadoUnidadePadrao ?? null
        this.atualizarSessaoUsuario(idSalvo)
        await authService.refreshToken()

        swalLoading.close()
        document.getElementById("btnFecharModalConfiguracoesUsuario")?.click()
        swalToast.fire("", this.$t("userSettings.saved"), "success")
      } catch (e) {
        swalLoading.close()
        Helper.messageExceptionHandler(e)
      } finally {
        this.salvando = false
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const el = document.getElementById("ModalConfiguracoesUsuario")
      if (!el) return
      this._onModalHidden = () => this.fecharModal()
      el.addEventListener("hidden.bs.modal", this._onModalHidden)
    })
  },
  beforeUnmount() {
    const el = document.getElementById("ModalConfiguracoesUsuario")
    if (el && this._onModalHidden)
      el.removeEventListener("hidden.bs.modal", this._onModalHidden)
  },
  watch: {
    abrir(value) {
      if (value)
        this.abrirModal()
    },
  },
}
</script>
